const items = [
  "You Grow It",
  "We Mow It",
  "Stripe · Edge · Repeat",
  "Crosscut Lawn Care",
  "Traverse City, MI",
  "Est. by Christian Brower",
];

export default function StripeMarquee() {
  const loop = [...items, ...items];
  return (
    <div
      data-testid="stripe-marquee"
      className="bg-[#0B1C14] border-y-2 border-[#0B1C14] py-5 overflow-hidden no-scrollbar"
    >
      <div className="marquee-track flex gap-12 whitespace-nowrap w-max">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display uppercase text-[#F4F3EF] text-3xl tracking-tight">
              {t}
            </span>
            <span
              className="inline-block w-3 h-3 bg-[#E64C23]"
              aria-hidden
            />
          </div>
        ))}
      </div>
    </div>
  );
}
